<template>
    <div class="step-container">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

        <h6 v-if="!schedules && !isLoading" class="content">No hay horarios de entrega para esta dirección.</h6>
        <h6 v-else class="content">Seleccioná el dia y horario de entrega para tu pedido</h6>

        <div v-if="schedules && !isLoading" style="margin-top: 10px;">
            <ul class="biglist">
                <template v-for="s in schedules">
                    <li :key="s.id" v-if="!s.full" @click="onScheduleSelected(s)">

                        <div class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <span class="address-title">{{ s.date | moment('dddd D') | capitalize }} de {{ s.date | moment('MMMM') | capitalize }}</span>
                                    <span class="address-subtitle">{{ s.start }} - {{ s.end }}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :key="s.id" v-else>
                        <div class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <span class="address-title">{{ s.date }}</span>
                                    <span class="address-subtitle has-text-danger">No disponible</span>
                                </div>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CheckoutDeliverySchedule',

        props: {
            zone: Object,
            address: Object
        },

        components: {},

        data() {
            return {
                isLoading: false,

                days: [],
                schedules: null
            }
        },

        mounted() {

        },

        watch: {
            async zone(value) {
                if(value == null) {
                    this.schedules = null;
                    return;
                }

                this.isLoading = true;

                // Clear the delivery schedule
                this.selectedSchedule = 0;
                this.schedules = {};

                // Request the schedules for the selected delivery address
                let response = await this.$api.getZoneAvailableSchedule(value.id);

                for(let schedule of response) {
                    try {
                        let result = await this.$api.get('/api/shipment_routes/availability', {
                            address: this.address.id,
                            date: schedule.date,
                            start: schedule.start,
                            end: schedule.end
                        });

                        schedule.full = !result.available;
                    }
                    catch (err) {
                        schedule.full = true;
                    }
                }

                this.schedules = response;

                this.isLoading = false;
            }
        },

        methods: {
            onScheduleSelected(value) {
                this.$emit('input', value);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .step-container {
        position: relative;
        min-height: 100px;
    }

    .table {
        width: 100%;

        th {
            text-transform: capitalize;
        }

        td {
            text-align: center;
        }

    }
</style>



